import Center from '@zenbusiness/zui/Center';
import Heading from '@zenbusiness/zui/Heading';
import Stack from '@zenbusiness/zui/Stack';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

import FullScreenDialog from '#client/components/FullScreenDialog';

export const InterstitialScreenRoot = superstyled({
  name: 'InterstitialScreen',
  slot: 'Root',
  tag: FullScreenDialog,
  propsAdded: {
    open: true
  }
});

export const InterstitialScreenContainer = superstyled({
  name: 'InterstitialScreen',
  slot: 'Container',
  tag: Center,
  propsAdded: {
    alignItems: 'center',
    m: 'auto',
    maxWidth: 480,
    spacing: 3,
    textAlign: 'center'
  }
});

export const InterstitialScreenContent = superstyled({
  name: 'InterstitialScreen',
  slot: 'Content',
  tag: Stack,
  propsAdded: {
    alignItems: 'center',
    spacing: 0.5
  }
});

export const InterstitialScreenTitle = superstyled({
  name: 'InterstitialScreen',
  slot: 'Title',
  tag: Heading,
  propsAdded: {
    component: 'h3',
    size: 'md',
    weight: 'medium'
  }
});

export const InterstitialScreenSubtitle = superstyled({
  name: 'InterstitialScreen',
  slot: 'Subtitle',
  tag: Text,
  propsAdded: {
    color: 'tertiary',
    size: 'sm'
  }
});
